// Function to add link icons to section headers
export default function initializeSectionLinks() {
    // Find all h2 elements within sections that have an id
    const sections = document.querySelectorAll('section[id]:not(.locked-section)');
    
    sections.forEach(section => {
        const h2 = section.querySelector('h2:not(.skip-menu)');

        if (h2 && section.id) {
            // Create link icon
            const linkIcon = document.createElement('a');
            linkIcon.href = `?i=${section.id}`;
            linkIcon.className = 'section-link';
            linkIcon.setAttribute('aria-label', `Link do sekcji: ${h2.textContent.trim()}`);
            linkIcon.setAttribute('title', 'Skopiuj link do tej sekcji');
            
            // Add link icon (using Unicode link symbol)
            linkIcon.innerHTML = '🔗';
            
            // Add click handler for copying link
            linkIcon.addEventListener('click', function(e) {
                e.preventDefault();
                
                // Get full URL with query param and hash
                const fullUrl = window.location.origin + window.location.pathname + `?i=${section.id}`;
                
                // Copy to clipboard
                copyToClipboard(fullUrl, linkIcon);
            });
            
            // Add the link icon to the h2
            h2.appendChild(linkIcon);
        }
    });
}

// Function to copy text to clipboard with visual feedback
function copyToClipboard(text, element) {
    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
            showCopyFeedback(element, true);
        }).catch(() => {
            // Fallback to older method
            fallbackCopyToClipboard(text, element);
        });
    } else {
        // Fallback for older browsers or non-secure contexts
        fallbackCopyToClipboard(text, element);
    }
}

// Fallback copy method for older browsers
function fallbackCopyToClipboard(text, element) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
        const successful = document.execCommand('copy');
        showCopyFeedback(element, successful);
    } catch (err) {
        showCopyFeedback(element, false);
    } finally {
        document.body.removeChild(textArea);
    }
}

// Show visual feedback when link is copied
function showCopyFeedback(element, success) {
    const originalContent = element.innerHTML;
    const originalTitle = element.title;
    
    if (success) {
        element.innerHTML = '✓';
        element.title = 'Link skopiowany!';
        element.style.color = '#28a745';
    } else {
        element.innerHTML = '❌';
        element.title = 'Błąd kopiowania';
        element.style.color = '#dc3545';
    }
    
    // Reset after 2 seconds
    setTimeout(() => {
        element.innerHTML = originalContent;
        element.title = originalTitle;
        element.style.color = '';
    }, 2000);
}